/// <amd-module name="Agile/Common/DataStructures/NumberSet" />
import produce from "immer";
import { ICustomSet } from "./SetContracts";
import { isNullOrUndefined } from "Agile/Common/Utils/NullCheck";

/**
 * A set of numbers
 */
export class NumberSet implements ICustomSet<number> {
    constructor(values?: number[]) {
        this._map = {};
        if (values) {
            const map = values.reduce((prev, next) => {
                prev[next] = 1;
                return prev;
            }, {});
            this._map = map;
        }
    }
    private _map: { [key: number]: number };
    public add = (val: number) => {
        if (isNullOrUndefined(val)) {
            return this;
        }
        const newMap = produce(this._map, draft => {
            if (!this.has(val)) {
                draft[val] = 1;
            }
        });
        if (newMap !== this._map) {
            const s = new NumberSet();
            s._map = newMap;
            return s;
        }
        return this;
    };
    public values = () => Object.keys(this._map).map(v => Number(v));
    public del = (val: number) => {
        if (isNullOrUndefined(val)) {
            return this;
        }
        const newMap = produce(this._map, draft => {
            if (this.has(val)) {
                delete draft[val];
            }
        });

        if (newMap !== this._map) {
            const s = new NumberSet();
            s._map = newMap;
            return s;
        }
        return this;
    };
    public has = (val: number) => {
        if (isNullOrUndefined(val)) {
            return false;
        }
        return this._map[val] !== undefined;
    };
    public length = () => Object.keys(this._map).length;
}
